import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const UploadDocumentIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9998 20.3334V13.3334L8.6665 15.6667"
        stroke="#13212F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13.3334L13.3333 15.6667"
        stroke="#13212F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1668 12.1667V18C26.1668 23.8334 23.8335 26.1667 18.0002 26.1667H11.0002C5.16683 26.1667 2.8335 23.8334 2.8335 18V11C2.8335 5.16669 5.16683 2.83336 11.0002 2.83336H16.8335"
        stroke="#13212F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1668 12.1667H21.5002C18.0002 12.1667 16.8335 11 16.8335 7.50003V2.83336L26.1668 12.1667Z"
        stroke="#13212F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
